(function () {
  'use strict';

  if (typeof micrositePopupData === 'undefined' || !micrositePopupData) {
    return;
  }

  var data = micrositePopupData;
  var storageKey = 'microsite_popup_seen_' + data.id;

  if (sessionStorage.getItem(storageKey)) {
    return;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.createElement('div');
    overlay.className = 'microsite-popup-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    var iconHtml = data.icon
      ? '<div class="microsite-popup-icon"><img src="' + data.icon + '" alt=""></div>'
      : '';

    var buttonHtml = data.button && data.button.url
      ? '<a class="microsite-popup-button" href="' + data.button.url + '" target="' + data.button.target + '">' + data.button.label + '</a>'
      : '';

    overlay.innerHTML =
      '<div class="microsite-popup">' +
        '<button type="button" class="microsite-popup-close" aria-label="Close">&times;</button>' +
        iconHtml +
        '<h3 class="microsite-popup-title">' + data.title + '</h3>' +
        '<div class="microsite-popup-text">' + data.text + '</div>' +
        buttonHtml +
      '</div>';

    document.body.appendChild(overlay);
    document.body.classList.add('microsite-popup-open');

    requestAnimationFrame(function () {
      overlay.classList.add('is-visible');
    });

    overlay.querySelector('.microsite-popup-close').addEventListener('click', function () {
      document.body.classList.remove('microsite-popup-open');
      overlay.classList.remove('is-visible');
      overlay.addEventListener('transitionend', function () {
        overlay.remove();
      }, { once: true });
      sessionStorage.setItem(storageKey, '1');
    });
  });
})();
